var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"integral"},[_c('div',{staticClass:"intCenter"},[_c('img',{attrs:{"src":require("../../../assets/images/nonet.png")}}),_vm._v(" "),_c('p',[_vm._v("啊哦，网络不太顺畅哦～")]),_vm._v(" "),_c('button',{staticClass:"redbtn",on:{"click":_vm.Reload}},[_vm._v("重新加载")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0399eab6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emptypage/noNet/noNet.vue
// module id = null
// module chunks = 